import React, { useContext } from "react";
import BillingContentPending from "./BillingContentPending";
import BillingDetails from "./BillingDetails";
import ConsolidatedBillingSelect from "./ConsolidatedBillingSelect";
import ConsolidatedBillingDetails from "./ConsolidatedBillingDetails";
import mainContext from "../context/MainContext/mainContext";

const PendingTab = () => {
  const { id, consolidatedMode, consolidatedBillingIds } =
    useContext(mainContext);

  if (consolidatedMode && consolidatedBillingIds?.length >= 2) {
    return <ConsolidatedBillingDetails />;
  }

  if (consolidatedMode) {
    return <ConsolidatedBillingSelect />;
  }

  return <>{id ? <BillingDetails /> : <BillingContentPending />}</>;
};

export default PendingTab;
